import type { GatsbyBrowser } from "gatsby"
import { getStoredCookieConsent } from "./src/utils/cookieConsent"
import { sendGa4PageView } from "./src/utils/loadGoogleAnalytics"

/**
 * GA4 does not automatically see Gatsby client-side route changes; send page_view on each navigation.
 */
export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  if (getStoredCookieConsent() !== "analytics") {
    return
  }
  const path = `${location.pathname}${location.search}${location.hash}`
  sendGa4PageView(path)
}
